import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Criterion } from 'shared/models/visitor-info/criterion-group';
import { countries } from 'shared/components/detailed-data/visitor-campaign-criterion/criterion-countries';

@Component({
  selector: 'app-visitor-campaign-criterion',
  templateUrl: './visitor-campaign-criterion.component.html',
  styleUrls: ['./visitor-campaign-criterion.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class VisitorCampaignCriterionComponent implements OnChanges {

  @Input()
  criterion: Criterion;

  @Input()
  operator: string;

  optionTypes = ['firstTimeVisitors', 'repeatVisitors', 'desktop', 'mobile'];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.criterion.currentValue.fieldName === 'visitorCountry') {
      changes.criterion.currentValue.fieldValues[0] = countries[changes.criterion.currentValue.fieldValues[0]];
    }
  }

  public isOptionType(fieldValue: string): boolean {
    return this.optionTypes.includes(fieldValue);
  }
}
